import Service from '@/service/index.js';
import { getComParamsTitle } from '@/utils/comConfig.js';
// 区域区分
export function citytitle () {
  return getComParamsTitle();
}
function formatDate (date, fmt) {
  let o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  for (let k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
  return fmt;
};

// 单位转换
export function unitChange (num, multiple) {
  const numStr = String(num);
  if (numStr.includes('.')) {
    const length = numStr.length - numStr.indexOf('.') - 1;
    const num2 = Math.pow(10, length);
    return (Number(num) * num2 / multiple / num2).toFixed(4);
  } else {
    return (Number(num) / multiple);
  }
}

// 保留两位小数
export function numberToFixedTwo (number) {
  if (!number) return 0;
  return Math.floor(((number) / 10000) * 100) / 100;
}
// 保留四位小数
export function numberToFixedFour (number) {
  if (!number) return 0;
  return Math.floor(number * 10000 / 10000) / 10000;
}
export function fullDate (dateText) {
  if (!dateText) { return ''; }
  const timeStr = new String(dateText).substr(0, 19).replace(/\-/g, '/').replace(/\T/g, ' ');
  return formatDate(new Date(new Date(timeStr).getTime() + 8 * 60 * 60 * 1000), 'yyyy-MM-dd hh:mm:ss');
}

export function fullDateOfChinese (dateText) {
  if (!dateText) { return ''; }
  const timeStr = new String(dateText).substr(0, 19).replace(/\-/g, '/').replace(/\T/g, ' ');
  return formatDate(new Date(new Date(timeStr).getTime() + 8 * 60 * 60 * 1000), 'yyyy年MM月dd日 hh:mm:ss');
}

export function baseDate (dateText) {
  if (!dateText) { return ''; }
  const timeStr = new String(dateText).substr(0, 19).replace(/\-/g, '/').replace(/\T/g, ' ');
  return formatDate(new Date(new Date(timeStr).getTime() + 8 * 60 * 60 * 1000), 'yyyy-MM-dd');
}

export function baseDateOfPoint (dateText) {
  if (!dateText) { return ''; }
  const timeStr = new String(dateText).substr(0, 19).replace(/\-/g, '/').replace(/\T/g, ' ');
  return formatDate(new Date(new Date(timeStr).getTime() + 8 * 60 * 60 * 1000), 'yyyy.MM.dd');
}

// 数字位数保留
export function numberStrToFixed (str, length = 2) {
  return (str * 1).toFixed(length);
}

// 码值翻译为汉字
export function translation (value, arr, itemNo, itemName) {
  if (!arr) { return; }
  const code = itemNo ? itemNo : 'code';
  const name = itemName ? itemName : 'value';
  return arr.find(item => String(item[code]) === String(value)) && arr.find(item => String(item[code]) === String(value))[name];
}

/**
 * 数组转化为对象
 */
export function arrayToMap (list, key, value) {
  const obj = {};
  if (list && list.length) {
    list.forEach(item => obj[item[key]] = item[value]);
  }
  return obj;
};

// 地区code转换为汉字
// 拆分区域编码
function splitAreaCode (areaCode) {
  const length = areaCode && areaCode.length;
  let region = {};
  if (!length) {
    return false;
  }
  // eslint-disable-next-line default-case
  switch (length) {
    case 2:
      region = {
        province: areaCode,
        city: null,
        district: null,
        town: null,
        village: null
      };
      return region;
    case 4:
      region = {
        province: areaCode.slice(0, 2),
        city: areaCode,
        district: null,
        town: null,
        village: null
      };
      return region;
    case 6:
      region = {
        province: areaCode.slice(0, 2),
        city: areaCode.slice(0, 4),
        district: areaCode,
        town: null,
        village: null
      };
      return region;
    case 9:
      region = {
        province: areaCode.slice(0, 2),
        city: areaCode.slice(0, 4),
        district: areaCode.slice(0, 6),
        town: areaCode,
        village: null
      };
      return region;
    case 12:
      region = {
        province: areaCode.slice(0, 2),
        city: areaCode.slice(0, 4),
        district: areaCode.slice(0, 6),
        town: areaCode.slice(0, 9),
        village: areaCode
      };
      return region;
  }
};

// 获取区域列表
function getLocationList (code, level, currentCode) {
  return new Promise((resolve) => {
    Service.getLocationList(code, level).then(res => {
      if (res) {
        let areaList = res.data;
        const areaName = areaList.find(v => v.areaCode === currentCode) && areaList.find(v => v.areaCode === currentCode).areaName;
        resolve(areaName);
      }
    });
  });
};
export async function translateAreaCode (village) {
  if (!village) { return; }
  const region = splitAreaCode(village);
  let district = await getLocationList(region.city, 3, region.district);
  return district;
}
